import * as actions from './actions'
import type { Action } from '../types'
import type { OpenApiSpecification, OperationSpec, Response } from './types'
import { success } from 'utilities/actions'

export type State = {
  specification: OpenApiSpecification;
  permissionsByOperationId: {
    [key: string]: Array<string>;
  };
  systemStatus: {
    apiVersion: string;
  };
};

const permissionsByOperationId = (specification: OpenApiSpecification | Record<any, any>): Response => {
  let permissionsByOperationId: Record<string, any> = {}

  if (!specification.paths || typeof specification.paths !== 'object') {
    return permissionsByOperationId
  }

  Object.values(specification.paths).forEach(pathSpec => {
    if (pathSpec && typeof pathSpec === 'object') {
      Object.values(pathSpec).forEach((operationSpec: OperationSpec | unknown) => {
// @ts-expect-error - TS2339 - Property 'operationId' does not exist on type '{}'.
        if (operationSpec && operationSpec.operationId) {
// @ts-expect-error - TS2339 - Property 'operationId' does not exist on type '{}'.
          const operationId = operationSpec.operationId

          if (typeof operationId === 'string') {
// @ts-expect-error - TS2339 - Property 'xPermissions' does not exist on type '{}'.
            permissionsByOperationId[operationId] = operationSpec.xPermissions || []
          }
        }
      })
    }
  })

  return permissionsByOperationId
}

export const initialState = {
  specification: {},
  permissionsByOperationId: {},
  systemStatus: {}
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly specification: {}; readonly permissionsByOperationId: {}; readonly systemStatus: {}; }' is not assignable to type 'State'.
  if (state === undefined) state = initialState
  switch (action.type) {
    case actions.FETCH_API_SPECIFICATION:
      return initialState
    case actions.FETCH_API_SPECIFICATION_SUCCESS:
      let { type, ...specification } = action
      return {
        ...state,
        specification,
        permissionsByOperationId: permissionsByOperationId(specification)
      }
    case success(actions.FETCH_SYSTEM_STATUS):
      let { release: apiVersion } = action

      return {
        ...state,
        systemStatus: {
          ...state.systemStatus,
          apiVersion
        }
      }
    default:
      return state
  }
}

export default reducer
